export const taskOperationsList = {
  newTask: "NEW_TASK",
  updateTask: "UPDATE_TASK",
  updateTaskTo: "UPDATE_TASK_TO",
  listTask: "LIST_TASK",
  previewTask: "PREVIEW_TASK",
};

export const TASK_STATUS = {
  IN_PROGRESS: "In-Progress",
  DONE: "Done",
};

export const ACCEPTANCE_STATUS = {
  PENDING: "Pending",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
};

export const TASK_LIST_TYPE = {
  CREATED_BY_ME_PENDING: {
    name: "Created By Me (Pending)",
    nameS: "By Me (Pending)",
    key: "CREATED_BY_ME_PENDING",
  },
  CREATED_BY_ME_ACCEPTED: {
    name: "Created By Me (Accepted)",
    nameS: "By Me (Accepted)",
    key: "CREATED_BY_ME_ACCEPTED",
  },
  ASSIGNED_TO_ME_PENDING: {
    name: "Assigned To Me (Pending)",
    nameS: "To Me (Pending)",
    key: "ASSIGNED_TO_ME_PENDING",
  },
  ASSIGNED_TO_ME_ACCEPTED: {
    name: "Assigned To Me (Accepted)",
    nameS: "To Me (Accepted)",
    key: "ASSIGNED_TO_ME_ACCEPTED",
  },
  REJECTED: { name: "Rejected Tasks", nameS: "Rejected", key: "REJECTED" },
  ACKNOWLEDGED: { name: "Done Tasks", nameS: "Done", key: "ACKNOWLEDGED" },
};

export const DASHBOARD_TASK_ACTIONS = [
  "PENDING",
  "ACCEPTED",
  "REJECTED",
  "DONE",
  "ACKNOWLEDGED",
];
